import React, { FC } from 'react';
import cn from 'classnames';
import s from './avatarBlock.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { Button } from '@components/UIKit/Button/Button';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
interface AvatarBlockLoaderProps {}
export const AvatarBlockLoader: FC<AvatarBlockLoaderProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <form className={s.avatarBlock} data-sentry-component="AvatarBlockLoader" data-sentry-source-file="AvatarBlockLoader.tsx">
            <div className={cn(s.avatarBlock__image, '_ibg')}>
                <Avatar srcSet={[{
        height: 132,
        width: 132,
        minMedia: 767.98
      }, {
        height: 87,
        width: 87,
        minMedia: 0
      }]} isLoading={true} profile={{
        avatar: {
          id: '',
          profileId: 0,
          isCopiedToBunny: false
        },
        shortid: ''
      }} data-sentry-element="Avatar" data-sentry-source-file="AvatarBlockLoader.tsx" />
            </div>
            <Button id='default_button' className={s.avatarBlock__loading} loading={true} size='medium' color='White' data-sentry-element="Button" data-sentry-source-file="AvatarBlockLoader.tsx">
                {tr({
        id: 'btn.loading'
      })}
            </Button>
        </form>;
};